module.exports = __webpack_public_path__ + "img/star.de08ce32.svg";